import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';

const CustomModal = ({ width, height, isOpen, setClose, center, overflow, id, children }) => {
	const [open, setOpen] = useState(false);

	const style = {
		width: width || '100%',
		height: height,
		maxHeight: '100vh',
		overflow: overflow || 'scroll',
		bgcolor: 'background.paper',
		border: '0px solid #000',
		borderRadius: '5px',
		boxShadow: 24,
		p: 4,
		...(center && {
			position: 'absolute',
			top: '50%',
			left: '50%',
			transform: 'translate(-50%, -50%)'
		})
	};

	const handleClose = () => {
		setClose && setClose();
		setOpen(false);
	};

	useEffect(() => {
		setOpen(isOpen);
	}, [isOpen]);

	return (
		<div>
			<Modal
				open={open}
				onClose={handleClose}
				data-testid={id}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
			>
				<Box id={'modal-box'} sx={style}>
					{children}
				</Box>
			</Modal>
		</div>
	);
};

export default CustomModal;
